import InsideThisBookEventTypes from "./types/InsideThisBookEventTypes";

const excerptsName = "Sample Pages";
const tocName = "Table of Contents";
const flapsName = "Flap Cover Text";

function getExcerpts(excerpts) {
	return {
		// V2 behavior, uses Id of first excerpt when multiple exist
		id: excerpts[0].ID,
		name: excerptsName,
		featureType: InsideThisBookEventTypes.SAMPLEPAGES_VIEW_CLICKED,
		body: excerpts.map((excerpt) => excerpt.Excerpt).join("<br/><br/>")
	};
}

function getToc(toc) {
	return {
		id: toc.ID,
		name: tocName,
		featureType: InsideThisBookEventTypes.TOC_VIEW_CLICKED,
		body: toc.Toc
	};
}

function getFlaps(flaps) {
	// Only using the first flap item in the array if there are multiple to match v2 behavior
	return {
		id: flaps[0].ID,
		name: flapsName,
		featureType: InsideThisBookEventTypes.FLAPCOVER_VIEW_CLICKED,
		body: flaps[0].Flap
	};
}

/**
* @returns an InsideThisBook object
*/
export function getBookContents(store) {

    let insideThisBook = [];
    let bookContents = store.FeatureContent.BookContents;

	if (bookContents) {
        let bookExcerpts = bookContents.excerpts;
        if (bookExcerpts && bookExcerpts.length > 0) {
            insideThisBook.push(getExcerpts(bookExcerpts));
        }

        let bookToc = bookContents.toc;
        if (bookToc) {
            insideThisBook.push(getToc(bookToc));
		}

		let flaps = bookContents.flaps;
		if (flaps && flaps.length > 0) {
			insideThisBook.push(getFlaps(flaps));
		}
    } else {
		return null;
	}

    return insideThisBook;
}

export function getBookContentsAsObject(store) {

    let bookContentsObject = {
		excerpts: undefined,
		toc:undefined,
		flaps:undefined
	};
    let bookContents = getBookContents(store);

	if (bookContents) {

		for(let index = 0; index < bookContents.length; index ++){
			switch(bookContents[index].name){
				case excerptsName:
					bookContentsObject.excerpts = {
						id: bookContents[index].id,
						body: bookContents[index].body
					}
					break;
				case tocName:
					bookContentsObject.toc = {
						id: bookContents[index].id,
						body: bookContents[index].body
					}
					break;
				case flapsName:
					bookContentsObject.flaps = {
						id: bookContents[index].id,
						body: bookContents[index].body
					}
					break;
			}
		}
        return bookContentsObject;
	}
	return null;
}



// WEBPACK FOOTER //
// ./src/data/InsideThisBookSelector.js